import * as zenscroll from 'zenscroll';

import {
	Component,
	ElementRef,
	HostBinding,
	HostListener,
	Injector,
	Input,
	NgZone,
	OnDestroy,
	OnInit,
	Renderer2,
} from '@angular/core';
import { filter, isEmpty, orderBy } from 'lodash';

import { BaseComponent } from '../../base.component';
import { LayoutService } from '../../../Services/layout/layout.service';
import { LoadTimeService } from '../../../Services/LoadTimeService/load-time-service';
import { Subscription } from 'rxjs';
import { PagesDurationService } from 'src/app/Services/pages-duration/pages-duration.service';

@Component({
	selector: 'content',
	template: `
		<div class="content-wrapper progress-accordion">
			<div class="content" *ngFor="let page of pages" [ngClass]="page.title">
				<control
					*ngFor="let control of page.controls; trackBy: trackById"
					context="page"
					[control]="control"
					[ngClass]="{
						'small-margin': control.controlType === 'AddressChange',
						'bundle-btn': control.name === 'ButtonLink.BackToBundle',
						'discount-checkboxes-wrapper': control.name === 'DiscountOptions'
					}"
				>
				</control>
			</div>
			<footer ng-class="globalAttributes.type" *ngIf="model && model.globalAttributes.version && showFooter"></footer>
		</div>
	`,
	styleUrls: ['./content.component.scss'],
})
export class ContentComponent extends BaseComponent implements OnInit, OnDestroy {
	@Input() showFooter: boolean;
	model: data;
	pages: any[];
	isFirstLoad: boolean;
	globalAttributes: {};
	subscriptions: Subscription[] = [];
	SCROLL_DURATION = 800;
	ANIMATION_TIMEOUT = 800;
	ERROR_ANIMATION_TIMEOUT = 800;
	SCROLL_OFFSET = 30;
	currentAction: string;
	isErrorExists: boolean;
	ajaxInfo: ajaxInfo;
	startTime: number;

	@HostBinding('class.showForMobile')
	showForMobile: boolean;

	constructor(
		injector: Injector,
		private LayoutService: LayoutService,
		private loadTimeService: LoadTimeService,
		private el: ElementRef,
		private renderer: Renderer2,
		private ngZone: NgZone,
		private pagesDurationService: PagesDurationService
	) {
		super(injector);
		this.pages = [];
		this.isFirstLoad = true;
	}

	async ngOnInit() {
		this.pagesDurationService.startDisplayTimer();
		this.isFirstLoad = true;
		this.subscriptions.push(
			this.LayoutService.staticLayout.subscribe((data) => {
				if (data && isEmpty(this.model)) {
					this.model = data.data;
					if (this.model.metadata && this.model.metadata.progressMeter) {
						this.showForMobile = true;
					}
					if (this.pages.length > 0) {
					} else {
						this.isFirstLoad = false;
						this.pages.push(this.model.ui.page);
						this.pages[0].controls = this.pages[0].controls.filter((c) => c.visible);
						this.pages[0].controls = orderBy(this.pages[0].controls, 'sequence');
					}
					this.tryInvokeActionOnLoad(data);
				}
				if (data && data.action === 'popup') {
					return;
				}
				this.ngZone.runOutsideAngular(() => {
					setTimeout(() => {
						if (
							document.getElementsByTagName('progress-accordion')[0] ||
							document.getElementsByTagName('headerprogressbar-panel')[0]
						) {
							const progBarRect = document.getElementsByTagName('progress-accordion')[0].getBoundingClientRect();
							const progBarHeader = document.getElementsByTagName('headerprogressbar-panel')[0].getBoundingClientRect();

							if (
								this.isErrorExists ||
								(this.currentAction &&
									(this.currentAction === 'Relevancy' ||
										this.currentAction === 'PreSubmissionLoader' ||
										this.currentAction === 'CustomPackageRelevancy' ||
										this.currentAction === 'EditCustomPackage'))
							) {
								return;
							} else if (progBarRect.height > 0) {
								zenscroll.toY(progBarRect.height, 0);
							} else if (progBarHeader.height > 0) {
								zenscroll.toY(0, progBarHeader.height);
							} else {
								zenscroll.toY(40, 0);
							}
							if (data) {
								this.handleSplunkPageLoad(data.splunkTimerId);
							}
						}
					}, 300);
				});
			})
		);

		this.subscriptions.push(
			this.layoutService.renderPageFromUISubject.subscribe((data) => {
				this.model = data.data;
				this.pages[0] = JSON.parse(JSON.stringify(this.model.ui.page));
				this.pages[0].controls = this.pages[0].controls.filter((c) => c.visible);
				this.pages[0].controls = orderBy(this.pages[0].controls, 'sequence');
			})
		);

		this.subscriptions.push(
			this.observablesService.pageUpdated.subscribe((pageEvent) => {
				this.currentAction = pageEvent.action;
				this.pageUpdate(pageEvent);
			})
		);

		// Prevent scroll in mobile sidebarPanel
		this.subscriptions.push(
			this.observablesService.openSidebar.subscribe((isOpen) => {
				if (isOpen) {
					this.renderer.setStyle(this.el.nativeElement, 'display', 'none');
				} else {
					this.renderer.setStyle(this.el.nativeElement, 'display', 'block');
				}
			})
		);
	}

	// perform additional ajax call (if need to invoke an additional action [e.g.: open modal right after rendering a page]):
	tryInvokeActionOnLoad(data: StaticContentModel) {
		if (data.data.globalAttributes) {
			const action: string = data.data.globalAttributes.invokeActionOnLoad;
			if (action) {
				const ajaxInfo = {
					action,
					stage: this.pages[0].stage,
					elementSrc: null,
					conditions: null,
					notRenderPage: null,
				};

				this.actionService.ajaxAction(ajaxInfo, this.context);
			}
		}
	}

	pageUpdate(pageUpdateEvent: pageUpdatedEvent) {
		if (this.isFirstLoad) {
			this.isFirstLoad = false;
			return;
		}

		const currentSection = this.pages[0];
		const newSection = this.LayoutService.staticLayout.getValue().data.ui.page;
		if (currentSection.title === newSection.title) {
			// If new section is the same as old one, then just replace current with new
			// this.pages[0].controls = newSection.controls;
			this.pages[0].controls = filter(newSection.controls, (c) => c.visible);
			this.pages[0].controls = orderBy(this.pages[0].controls, 'sequence');
			this.observablesService.UpdateBinding.next(this.pages[0].controls);

			// scroll to first error (if any)
			setTimeout(() => {
				const errorElem = document.getElementById('error-container');
				if (errorElem && pageUpdateEvent && pageUpdateEvent.action !== 'Relevancy') {
					this.isErrorExists = true;
					var headerName = 'header';
					//dr header
					if (!document.getElementsByTagName(headerName)[0]) headerName = 'header-dr';
					if (document.getElementsByTagName(headerName)[0]) {
						zenscroll.setup(
							this.SCROLL_DURATION,
							document.getElementsByTagName(headerName)[0].getBoundingClientRect().height + this.SCROLL_OFFSET
						);
						zenscroll.to(errorElem);
					}
				}
				this.handleSplunkPageLoad(pageUpdateEvent.splunkTimerId);
			}, this.ERROR_ANIMATION_TIMEOUT);
		} else {
			// Scroll if new section !== current section
			// Add the next section to the pages array, over which ng-repeat iterates and renders sections
			this.pagesDurationService.calculateDisplayTime(this.pages[0].stage);

			this.isErrorExists = false;
			this.scrollToNextSection(newSection.title, pageUpdateEvent.splunkTimerId);
		}

		this.observablesService.pageUpdatedFinished.next();

		// perform additional ajax call (if need to invoke an additional action [e.g.: open modal right after rendering a page]):
		const globalAttributes = this.storeService.getGlobalAttributes();
		let actionToBeInvoked = '';

		if (globalAttributes) {
			actionToBeInvoked = globalAttributes.invokeActionOnLoad;

			if (actionToBeInvoked) {
				this.ajaxInfo = {
					action: actionToBeInvoked,
					stage: this.pages[0].stage,
					elementSrc: null,
					conditions: null,
					notRenderPage: null,
				};

				this.actionService.ajaxAction(this.ajaxInfo, this.context);
			}
		}
	}

	scrollToNextSection(sectionTitle, splunkTimerId: string) {
		// Get new page reference
		const copyObj = { ...this.LayoutService.staticLayout.getValue().data.ui.page };
		let isExist = false;

		// Detect if page already exist in history
		if (this.pages.filter((page) => page.stage === copyObj.stage).length > 0) {
			isExist = true;
		}

		// Page not exist, insert to array
		if (!isExist) {
			this.pages.push(copyObj);
			if (!isEmpty(this.pages[1].controls)) {
				this.pages[1].controls = this.pages[1].controls.filter((c) => c.visible);
			}
		}

		// If have more than 2 pages, cut from the beginning
		while (this.pages.length > 2) {
			this.pages.shift();
		}
		const el = document.getElementsByClassName('content')[0] as HTMLElement;

		el.classList.add('fade');
		el.style.height = `${el.getBoundingClientRect().height}px`;
		el.style.paddingTop = '0';
		// Let digest run first, and render the next section
		setTimeout(() => {
			this.myTimeout(splunkTimerId);
		}, 300);
	}

	myTimeout(splunkTimerId) {
		const nextSectionElement =
			this.model.metadata.page.state !== 'preloader'
				? (document.querySelectorAll('.content-wrapper > .content')[1] as HTMLElement)
				: (document.querySelector('preloader').firstElementChild as HTMLElement);

		// Scroll to the next section
		if (nextSectionElement) {
			// oldContent.slideUp(this.SCROLL_DURATION);
			const el = document.getElementsByClassName('content')[0] as HTMLElement;
			el.classList.add('slideUp');
		}

		// Bulletproof is for some reason scroll not occurred, then call shift & digest
		setTimeout(() => {
			if (this.pages.length > 1) {
				this.handleSplunkPageLoad(splunkTimerId);
				this.pages.shift();
				if (!isEmpty(this.pages[0].controls)) {
					this.pages[0].controls = this.pages[0].controls.filter((c) => c.visible);
					this.pages[0].controls = orderBy(this.pages[0].controls, 'sequence');
				}
			}
		}, this.ANIMATION_TIMEOUT);
	}

	@HostListener('window:beforeunload', ['$event'])
	unloadHandler(event) {
		this.pagesDurationService.calculateDisplayTime(this.pages[0].stage);
		this.pagesDurationService.sendDurations(this.pages[0].stage);
	}

	ngOnDestroy() {
		for (let sub of this.subscriptions) {
			sub.unsubscribe();
		}
	}

	trackById(index, item) {
		return item.id;
	}

	handleSplunkPageLoad(splunkTimerId: string) {
		if (this.observablesService.ShouldPageLoadEvent && splunkTimerId) {
			const dir = this.observablesService.ShouldPageLoadEvent;
			this.observablesService.ShouldPageLoadEvent = null;
			this.loadTimeService.endTimeMeasure(splunkTimerId);
			var timeLoad = this.loadTimeService.calculateTimeMeasure(splunkTimerId);

			this.splunkAnalyticsService.publish('pageLoad', '', {
				...timeLoad,
				direction: dir,
			});
		}
	}
}
